import { EnumForwardModes } from "../asn1/EUCSrv/stubs/ENetUC_CTI";

/**
 * Helper for user presence (channels, info)
 */
export default class UserPresenceHelper {
	/**
	 * Get label for the forwarded line according to the forward mode
	 * @param forwardMode - the forward mode
	 * @returns - a string to be used with the translator i18next
	 */
	public static getChannelCallForwardLabelByForwardMode(forwardMode: EnumForwardModes): string {
		switch (forwardMode) {
			case EnumForwardModes.eFORWARDMODEIMMEDIATE:
				return "IDS_CHANNEL_CALL_FORWARD_ALL";
			case EnumForwardModes.eFORWARDMODEBUSY:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_IF_BUSY";
			case EnumForwardModes.eFORWARDMODEBUSYINT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_INTERNALS_IF_BUSY";
			case EnumForwardModes.eFORWARDMODEBUSYEXT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_EXTERNALS_IF_BUSY";
			case EnumForwardModes.eFORWARDMODEIMMINT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_INTERNALS";
			case EnumForwardModes.eFORWARDMODEIMMEXT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_EXTERNALS";
			case EnumForwardModes.eFORWARDDISC:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_IF_NOT_LOGGED_IN";
			case EnumForwardModes.eFORWARDDISCINT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_INTERNALS_IF_NOT_LOGGED_IN";
			case EnumForwardModes.eFORWARDDISCEXT:
				return "IDS_CHANNEL_CALL_FORWARD_ALL_EXTERNALS_IF_NOT_LOGGED_IN";
			default:
				return "";
		}
	}
}
